import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';
import { Dthc } from '../../../Modules';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import EventSegmentShow from '../../../Event/EventSegment/EventSegmentShow';
import EventSegmentMobile from '../../../Event/EventSegment/EventSegmentMobile';
import EventSegmentDesktop from '../../../Event/EventSegment/EventSegmentDesktop';

const ScheduleComponent = ({
  addEventSegment,
  closeNewEventSegmentEditor,
  createEventSegment,
  deleteEventSegment,
  eventSegments,
  eventSegmentChangeHandler,
  localEventSegments,
  newEventSegment,
  newEventSegmentChangeHandler,
  editingNewEventSegment,
  readOnly,
  resetAddEventSegment,
  resetEditEventSegment,
  updateEventSegment,
  viewer
}) =>
  <div>
    {eventSegments.length === 0 &&
      !editingNewEventSegment &&
      !readOnly &&
      <div style={{ textAlign: 'center', padding: '2em' }}>
        <h4>This event has no schedule</h4>
        <br />
        <Button
          basic
          icon='plus'
          onClick={addEventSegment}
          labelPosition='left'
          content='Add Time & Place'
        />
      </div>}
    {!readOnly &&
      <div>
        {eventSegments.map((eventSegment, idx) =>
          <div key={eventSegment.node.id || idx}>
            <Dthc
              eventSegment={eventSegment.node}
              localEventSegment={localEventSegments[idx].node}
              onChange={segment => {
                eventSegmentChangeHandler(segment, idx);
              }}
              commitUpdate={updateEventSegment}
              desktop={EventSegmentDesktop}
              mobile={EventSegmentMobile}
              index={idx}
              reset={resetEditEventSegment}
              delete={deleteEventSegment}
              viewer={viewer}
            >
              <EventSegmentShow noBorder eventSegment={eventSegment.node} />
            </Dthc>
          </div>
        )}
      </div>}
    {readOnly &&
      <div>
        {eventSegments.map((eventSegment, idx) =>
          <div key={eventSegment.node.id || idx}>
            <EventSegmentShow
              noBorder
              readOnly={readOnly}
              eventSegment={eventSegment.node}
            />
          </div>
        )}
      </div>}
    <ReactCSSTransitionGroup
      transitionName='slide'
      transitionEnterTimeout={300}
      transitionLeaveTimeout={300}
    >
      {newEventSegment &&
        editingNewEventSegment &&
        <div>
          <Dthc
            eventSegment={newEventSegment.node}
            localEventSegment={newEventSegment.node}
            onChange={segment => {
              newEventSegmentChangeHandler(segment);
            }}
            commitUpdate={createEventSegment}
            desktop={EventSegmentDesktop}
            mobile={EventSegmentMobile}
            reset={resetAddEventSegment}
            initiallyOpen
            isNew
            delete={resetAddEventSegment}
            closeEditor={closeNewEventSegmentEditor}
            editorOpen={editingNewEventSegment}
            viewer={viewer}
          >
            <EventSegmentShow eventSegment={newEventSegment.node} />
          </Dthc>
        </div>}
    </ReactCSSTransitionGroup>
    {eventSegments.length > 0 &&
      !readOnly &&
      <div style={{ marginTop: '2em' }}>
        <a onClick={addEventSegment}>
          + Add Time and Place
        </a>
      </div>}
  </div>;

ScheduleComponent.propTypes = {
  addEventSegment: PropTypes.func.isRequired,
  closeNewEventSegmentEditor: PropTypes.func.isRequired,
  createEventSegment: PropTypes.func.isRequired,
  deleteEventSegment: PropTypes.func.isRequired,
  eventSegments: PropTypes.array.isRequired,
  eventSegmentChangeHandler: PropTypes.func.isRequired,
  editingNewEventSegment: PropTypes.bool.isRequired,
  localEventSegments: PropTypes.array.isRequired,
  newEventSegment: PropTypes.object,
  newEventSegmentChangeHandler: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  resetAddEventSegment: PropTypes.func.isRequired,
  resetEditEventSegment: PropTypes.func.isRequired,
  updateEventSegment: PropTypes.func.isRequired,
  viewer: PropTypes.object
};

export default ScheduleComponent;



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/Schedule/Schedule.js